import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import arrow from "../../assets/images/icons/chevron-right.svg";

interface Props {
  to?: string;
  label: string;
  icon?: string;
  onClick?: () => void;
  className?: string;
  isActive?: boolean;
}

const TitleSideLink: React.FC<Props> = ({
  to,
  label,
  icon,
  onClick,
  isActive: propIsActive,
  className,
}) => {
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    } else if (to) {
      if (window.innerWidth <= 1024) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        window.scrollTo(0, 0);
      }
    }
  };

  const basePath = to ? to.split("?")[0] : "";

  // Determine if the item should be active
  const getIsActive = (navLinkActive?: boolean): boolean => {
    if (propIsActive !== undefined) {
      return propIsActive;
    }
    if (navLinkActive !== undefined) {
      return (
        navLinkActive ||
        (to ? window.location.pathname.startsWith(`/${basePath}`) : false)
      );
    }
    return false;
  };

  if (!to && onClick) {
    const isActiveItem = propIsActive || false;

    return (
      <button
        onClick={handleClick}
        className={`text-primary-textFont flex w-full items-center justify-between overflow-hidden rounded-lg border p-2 transition-all hover:border hover:border-primary hover:bg-primary-bg hover:font-bold ${
          isActiveItem
            ? "border-primary bg-primary-bg font-bold"
            : `border-white ${className}`
        }`}
      >
        <div className="flex items-center gap-2">
          {icon && (
            <img
              src={icon}
              alt={t(label)}
              className="h-6 w-6"
              style={{
                filter: isActiveItem
                  ? "brightness(0) saturate(100%) invert(22%) sepia(98%) saturate(1888%) hue-rotate(200deg) brightness(96%) contrast(101%)"
                  : "brightness(0)",
              }}
            />
          )}
          <span>{t(label)}</span>
        </div>
        <img
          src={arrow}
          alt="arrow"
          className="h-5 w-5 rtl:-scale-100"
          style={{
            filter: isActiveItem
              ? "brightness(0) saturate(100%) invert(22%) sepia(98%) saturate(1888%) hue-rotate(200deg) brightness(96%) contrast(101%)"
              : "brightness(0)",
          }}
        />
      </button>
    );
  }

  return (
    <NavLink
      to={to!}
      replace
      onClick={handleClick}
      className={({ isActive: navLinkActive }) => {
        const isActiveItem = getIsActive(navLinkActive);

        return `text-primary-textFont flex items-center justify-between overflow-hidden rounded-lg border p-2 transition-all hover:border hover:border-primary hover:bg-primary-bg hover:font-bold ${
          isActiveItem
            ? "border-primary bg-primary-bg font-bold"
            : `border-white ${className}`
        }`;
      }}
    >
      {({ isActive: navLinkActive }) => {
        const isActiveItem = getIsActive(navLinkActive);

        return (
          <>
            <div className="flex items-center gap-2">
              {icon && (
                <img
                  src={icon}
                  alt={t(label)}
                  className="h-6 w-6"
                  style={{
                    filter: isActiveItem
                      ? "brightness(0) saturate(100%) invert(22%) sepia(98%) saturate(1888%) hue-rotate(200deg) brightness(96%) contrast(101%)"
                      : "brightness(0)",
                  }}
                />
              )}
              <span>{t(label)}</span>
            </div>
            <img
              src={arrow}
              alt="arrow"
              className="h-5 w-5 rtl:-scale-100"
              style={{
                filter: isActiveItem
                  ? "brightness(0) saturate(100%) invert(22%) sepia(98%) saturate(1888%) hue-rotate(200deg) brightness(96%) contrast(101%)"
                  : "brightness(0)",
              }}
            />
          </>
        );
      }}
    </NavLink>
  );
};

export default TitleSideLink;
